"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CombineSection = void 0;
var BasketUpdatedEvent = _interopRequireWildcard(require("@ori-events/basket-updated"));
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactCoolInview = require("react-cool-inview");
var _api = require("../../api");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _CombineDialog = require("../CombineDialog");
var _CombineSectionSkeleton = require("./CombineSectionSkeleton");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
/* eslint-disable react/jsx-no-bind -- x */

const CombineSection = () => {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    setShouldMutateCombineSection,
    shouldMutateCombineSection
  } = (0, _contexts.useBasketContext)();
  const [isCombineDialogOpen, setIsCombineDialogOpen] = (0, _react.useState)(false);
  const {
    inView,
    observe
  } = (0, _reactCoolInview.useInView)({
    rootMargin: '100px'
  });
  const {
    isMoreDesktop,
    isMoreMobile,
    subscriptions = [],
    subscriptionItemsCount,
    mutateSubscriptions,
    isValidating
  } = (0, _api.useGetSubscriptions)(inView || shouldMutateCombineSection);
  (0, _react.useEffect)(() => {
    const onBasketUpdate = async () => {
      if (shouldMutateCombineSection) {
        setShouldMutateCombineSection(false);
        await mutateSubscriptions();
      }
    };
    window.addEventListener(BasketUpdatedEvent.Name, onBasketUpdate);
    return () => {
      window.removeEventListener(BasketUpdatedEvent.Name, onBasketUpdate);
    };
  });
  if (isValidating) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: observe,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CombineSectionSkeleton.CombineSectionSkeleton, {})
    });
  }
  if (!subscriptions.length) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: observe
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CombineSectionButton, {
      ref: observe,
      "data-testid": getTestId('combine-section'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CombineSectionContent, {
        onClick: () => setIsCombineDialogOpen(true),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CombineContentWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Description, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
              variant: "h6",
              children: formatMessage('combineYourOrder')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
              color: "textSecondary",
              children: formatMessage('enjoyFreeShipping')
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.OnlyDesktop, {
            "data-testid": getTestId('combine-section-content-desktop'),
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SubscriptionItemsWrapper, {
              children: [subscriptions.slice(0, _constants.MAX_DESKTOP_ITEMS - (isMoreDesktop ? 1 : 0)).map(({
                personalSubscriptionId,
                product
              }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CheckoutImageWrapper, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.CheckoutImage, {
                  src: product?.imageUrl ?? 'noImage',
                  alt: product?.concept?.name ?? '',
                  title: product?.concept?.name ?? '',
                  background: _mui.theme.palette.grey[100],
                  width: "80px",
                  height: "80px"
                }, personalSubscriptionId)
              }, personalSubscriptionId)), isMoreDesktop ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubscriptionItemPlusWrapper, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
                  color: "textSecondary",
                  children: ["+", subscriptionItemsCount - _constants.MAX_DESKTOP_ITEMS + 1]
                })
              }) : null]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.OnlyMobile, {
            "data-testid": getTestId('combine-section-content-mobile'),
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.SubscriptionItemsWrapper, {
              children: [subscriptions.slice(0, _constants.MAX_MOBILE_ITEMS - (isMoreMobile ? 1 : 0)).map(({
                personalSubscriptionId,
                product
              }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CheckoutImageWrapper, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.CheckoutImage, {
                  src: product?.imageUrl ?? 'noImage',
                  alt: product?.concept?.name ?? '',
                  title: product?.concept?.name ?? '',
                  background: _mui.theme.palette.grey[100],
                  width: "80px",
                  height: "80px"
                }, personalSubscriptionId)
              }, personalSubscriptionId)), isMoreMobile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubscriptionItemPlusWrapper, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
                  color: "textSecondary",
                  children: ["+", subscriptionItemsCount - _constants.MAX_MOBILE_ITEMS + 1]
                })
              }) : null]
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CombineDialog.CombineDialog, {
      isCombineDialogOpen: isCombineDialogOpen,
      setIsCombineDialogOpen: setIsCombineDialogOpen,
      subscriptions: subscriptions,
      mutateSubscriptions: mutateSubscriptions
    })]
  });
};
exports.CombineSection = CombineSection;